import React, { Fragment } from 'react';
import CALVI_example from './CALVI_example.png';
import MI_Symptom_App_Screenshot from './MI_Symptom_App_Screenshot.PNG';
import UROP_Screenshot from './UROP_Screenshot.PNG';
import MDP_Project_Intro_Slide_Screenshot from './MDP_Project_Intro_Slide_Screenshot.PNG';
import adaptive_flow from './adaptive_flow.png';
import vframer_logo from './vframer_logo.png';
import vila_logo from './vila_logo.png';
import avec_logo from './avec_logo.png';
import vislit_autoethnography_banner from './vislit_autoethnography_banner.png';

function Research() {
	return (
		<Fragment>
			<div class="research" id="researchSection">
				<h2>Project Highlights</h2>
				<div class="experience">
					<div class="projectDetails">
						<div>
							<img class="block" src={vislit_autoethnography_banner} alt="autoethnography teaser"/>
						</div>
						<div class="details">
						<br></br>
							<p>We propose several calls to action aimed at tackling the wicked problem of visualization literacy measurement, such as by broadening test scopes and modalities, improving test ecological validity, making it easier to use tests, seeking interdisciplinary collaboration, and drawing from continued dialogue on visualization literacy to expect and be more comfortable with its fluidity.</p>
						</div>
					</div>
					<div class="no-top-margin publication">
						<p class="no-top-margin"><b>An Autoethnography on Visualization Literacy: A Wicked Measurement Problem</b></p>
						<p><b>Lily W. Ge</b>, Anne-Flore Cabouat, Karen Bonilla, Yuan Cui, Yiren Ding, Noëlle Rakotondravony, Mackenzie Michael Creamer, Jasmine Tan Otto, Maryam Hedayati, Bum Chul Kwon, Angela Locoro, Lane Harrison, Petra Isenberg, Michael Correll, Matthew Kay</p>
						<p>IEEE Trans. Visualization & Comp. Graphics (Proc. VIS) 2025</p>
						<p><a target="_blank" rel="noopener noreferrer" href="https://osf.io/dfr4p_v2/">[ PDF ]</a> <a target="_blank" rel="noopener noreferrer" href="https://osf.io/xwr4c/">[ OSF ]</a></p>
					</div>
					<div class="projectDetails">
						<div>
							<img class="block" src={avec_logo} alt="AVEC teaser"/>
						</div>
						<div class="details">
						<br></br>
							<p>We aim to expand measurements to construction-related abilities in visualization literacy and systematically develop AVEC to assess the visual encoding ability: the ability to appropriately map data to visual channel(s) for effectively answering data-relevant questions. </p>
						</div>
					</div>
					<div class="no-top-margin publication">
						<p class="no-top-margin"><b>AVEC: An Assessment of Visual Encoding Ability in Visualization Construction</b></p>
						<p><b>Lily W. Ge</b>, Yuan Cui, Matthew Kay</p>
						<p>ACM Human Factors in Computing Systems (CHI) 2025</p>
						<p><a target="_blank" rel="noopener noreferrer" href="https://osf.io/preprints/osf/kz58f_v1">[ PDF ]</a> <a target="_blank" rel="noopener noreferrer" href="https://osf.io/hg7kx/">[ OSF ]</a><a target="_blank" rel="noopener noreferrer" href="https://avec-live-demo.vercel.app/">[ AVEC demo ]</a></p>
					</div>
					<div class="projectDetails">
						<div>
							<img class="block" src={vila_logo} alt="VILA teaser"/>
						</div>
						<div class="details">
						<br></br>
							<p>Through an iterative design process, we develop the VILA (Visualization Items Generated by Large LAnguage Models) pipeline, for efficiently generating visualization items that measure people’s ability to accomplish visualization tasks.</p>
						</div>
					</div>
					<div class="no-top-margin publication">
						<p class="no-top-margin"><b>Promises and Pitfalls: Using Large Language Models to Generate Visualization Items</b></p>
						<p>Yuan Cui, <b>Lily W. Ge</b>, Yiren Ding, Lane Harrison, Fumeng Yang, Matthew Kay</p>
						<p>IEEE Trans. Visualization & Comp. Graphics (Proc. INFOVIS) 2024</p>
						<p><a target="_blank" rel="noopener noreferrer" href="https://osf.io/preprints/osf/au3er">[ PDF ]</a> <a target="_blank" rel="noopener noreferrer" href="https://osf.io/ysrhq/">[ OSF ]</a></p>
					</div>
					<div class="projectDetails">
						<div>
							<img class="block" src={vframer_logo} alt="V-FRAMER snapshot"/>
						</div>
						<div class="details">
							<p>"How can we guard against more subtle errors in reasoning when designing visualizations?"</p>
							<p>A visualization framework that captures knowledge in avoiding pitfalls in visualization creation.</p>
						</div>
					</div>
					<div class="no-top-margin publication">
						<p class="no-top-margin"><b>V-FRAMER: Visualization Framework for Mitigating Reasoning Errors in Public Policy</b></p>
						<p><b>Lily W. Ge</b>, Matthew Easterday, Matthew Kay, Evanthia Dimara, Peter Cheng, and Steven L Franconeri</p>
						<p>ACM Human Factors in Computing Systems (CHI) 2024</p>
						<p><a target="_blank" rel="noopener noreferrer" href="https://osf.io/y3pd6/">[ PDF ]</a> <a target="_blank" rel="noopener noreferrer" href="https://osf.io/q3uta/">[ OSF ]</a></p>
					</div>
					<div class="projectDetails">
						<div>
							<img class="block" src={adaptive_flow} alt="adaptive flow"/>
						</div>
						<div class="details">
							<p>Assessments developed to adaptively measure people's visualization literacy.</p>
							<p>A-VLAT and A-CALVI each contains half the number of questions than their original versions and still measures the same set of skills.</p>
						</div>
					</div>
					<div class="no-top-margin publication">
						<p class="no-top-margin"><b>Adaptive Assessment of Visualization Literacy</b></p>
						<p>Yuan Cui, <b>Lily W. Ge</b>, Yiren Ding, Fumeng Yang, Lane Harrison, and Matthew Kay</p>
						<p>IEEE Trans. Visualization & Comp. Graphics (Proc. INFOVIS) 2023</p>
						<p><a target="_blank" rel="noopener noreferrer" href="https://arxiv.org/pdf/2308.14147.pdf">[ PDF ]</a> <a target="_blank" rel="noopener noreferrer" href="https://osf.io/a6258/">[ OSF ]</a></p>
					</div>
					<div class="projectDetails">
						<div>
							<img class="block" src={CALVI_example} alt="CALVI example"/>
						</div>
						<div class="details">
							<p>"How well can the general public identify misinformation in visualizations?"</p>
							<p>An assessment developed to measure people's susceptibility to visualization misinformation.</p>
							<p>With a focus on the critical thinking, <i>CALVI</i> offers new perspectives on the notion of visualization literacy.</p>
						</div>
					</div>
					<div class="no-top-margin publication">
						<p class="no-top-margin"><b>CALVI: Critical Thinking Assessment for Literacy in Visualizations</b></p>
						<p><b>Lily W. Ge</b>, Yuan Cui, Matthew Kay</p>
						<p>ACM Human Factors in Computing Systems (CHI) 2023 | <span class="award">Honorable Mention Award (top 5%)</span></p>
						<p><a target="_blank" rel="noopener noreferrer" href="https://osf.io/32mg7">[ PDF ]</a> <a target="_blank" rel="noopener noreferrer" href="https://osf.io/pv67z/">[ OSF ]</a><a target="_blank" rel="noopener noreferrer" href="https://calvi-test.vercel.app/">[ CALVI online ]</a></p>
					</div>
					<div class="projectDetails">
						<div>
							<img class="block" src={MI_Symptom_App_Screenshot} alt="MI Symptom App Screenshot"/>
						</div>
						<div class="details">
							<p><b>MI Symptoms App</b></p>
							<p>A statewide online tool to help individuals and employers in the state of Michigan to check for symptoms related to COVID-19 and help businesses reopen safely.</p>
							<p>An effort to help Michigan public health officials to discover and prevent any possible COVID-19 outbreaks in the state of Michigan.</p>
							<li>Focus on User Interface development and improving user experience</li>
							<p><a target="_blank" rel="noopener noreferrer" href="https://cse.engin.umich.edu/stories/students-lead-the-way-on-state-of-michigan-web-application-to-help-curb-the-spread-of-covid-19">Learn more</a></p>
						</div>
					</div>
					<div class="projectDetails">
						<div>
							<img class="block" src={UROP_Screenshot} alt="UROP Screenshot"/>
						</div>
						<div class="details">
							<p><b>Alexa Let's Chat</b></p>
							<p>Worked with the University of Michigan Audrey team and competed in the Amazon’s Alexa Prize competition: Alexa Prize Socialbot Grand Challenge 3, and the team entered semi-finals.</p>
							<ul>
								<li>Investigated relationships between user experience and chatbot conversation topics</li>
								<li>Improved topical modules and conversation initiators based on user feedback analysis</li>
							</ul>

						</div>
					</div>
					<div class="no-top-margin publication">
						<p class="no-top-margin"><b>Audrey: A Personalized Open-Domain Conversational Bot</b></p>
						<p>Chung Hoon Hong, Yuan Liang, Sagnik Sinha Roy, Arushi Jain, Vihang Agarwal, Ryan Draves, Zhizhuo Zhou, William Chen, Yujian Liu, Martha Miracky, <b>Lily Ge</b>, Nikola Banovic, David Jurgens</p>
						<p>3rd Proceedings of Alexa Prize (Alexa Prize 2019)</p>
						<p><a target="_blank" rel="noopener noreferrer" href="https://m.media-amazon.com/images/G/01/mobile-apps/dex/alexa/alexaprize/assets/challenge3/proceedings/U-Michigan-Audrey.pdf">[ PDF ]</a></p>
					</div>
					{/*<div class="projectDetails">
						<div>
							<img class="block" src={MDP_Project_Intro_Slide_Screenshot} alt="MDP Project Intro Slide Screenshot"/>
						</div>
						<div class="details">
							<p><b>Multidisciplinary Design Program: Honda Project</b></p>
							<p>Student Software Engineer for Honda R&D Americas, Inc.</p>
							<p>Work with the Honda team to develop Machine Learning algorithms to detect wrong-way driving scenarios and integrate algorithm with embedded systems to create Vehicle-to-Vehicle (V2V) communication system to warn drivers.</p>
						</div>
					</div>*/}
				</div>
			</div>
		</Fragment>
	)
}

export { Research }